export const SET_CURRENT_USER = 'SET_CURRENT_USER';



/** WEBPACK FOOTER **
 ** ./src/actions/types.js
 **/